import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-star-ranker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './star-ranker.component.html',
  styleUrl: './star-ranker.component.scss'
})
export class StarRankerComponent {
  @Input()
  rank: number = 1;

  @Input()
  isError = false;
}
